export type EncounterSpecialty =
  | "endoscopy"
  | "ophthalmology"
  | "well_baby"
  | "chemo"
  | "haematology"
  | "infusion"
  | "rfl_automation";

export const MASTRA_STUDIO_DEFAULT_BASE = "https://studio.internal.jigsaw.codes";

const ENDOSCOPY_STUDIO_WORKFLOW = "endoscopySummaryEncounterWorkflow";

export const SPECIALTY_TO_STUDIO_WORKFLOW: Partial<Record<EncounterSpecialty, string>> = {
  endoscopy: ENDOSCOPY_STUDIO_WORKFLOW,
  ophthalmology: "classifyOphthalmologyEncounterWorkflow",
  well_baby: "classifyWellBabyEncounterWorkflow",
  chemo: "classifyChemoEncounterWorkflow",
  haematology: "classifyChemoEncounterWorkflow",
};

// Map is Partial (infusion and any future no-workflow specialty are absent), so
// the endoscopy fallback is referenced by name rather than read back off the map.
const DEFAULT_WORKFLOW = ENDOSCOPY_STUDIO_WORKFLOW;

export function getMastraRunUrl(
  workflowName: string,
  runId: string,
  baseUrl: string = MASTRA_STUDIO_DEFAULT_BASE,
): string {
  return `${baseUrl}/workflows/${workflowName}/graph/${runId}`;
}

/**
 * Returns the Mastra Studio URL for viewing a classification workflow run.
 * Falls back to the endoscopy workflow when the specialty is missing or unknown,
 * matching the QA app's "View Run" link behaviour.
 */
export function getMastraWorkflowRunUrl(
  specialty: EncounterSpecialty | null | undefined,
  runId: string,
  baseUrl: string = MASTRA_STUDIO_DEFAULT_BASE,
): string {
  const workflow = (specialty && SPECIALTY_TO_STUDIO_WORKFLOW[specialty]) ?? DEFAULT_WORKFLOW;
  return getMastraRunUrl(workflow, runId, baseUrl);
}

export function getInvestigatorMastraRunUrl(runId: string, baseUrl: string = MASTRA_STUDIO_DEFAULT_BASE): string {
  return getMastraRunUrl("codingInvestigatorWorkflow", runId, baseUrl);
}

export function getAuditMastraRunUrl(runId: string, baseUrl: string = MASTRA_STUDIO_DEFAULT_BASE): string {
  return getMastraRunUrl("codeRuleAuditWorkflow", runId, baseUrl);
}
